import React, { useState, useEffect } from 'react';
import { DependenteEntidade, PlanoVinculadoEntidade, ProcessoBeneficioEntidade } from '../../../entidades';
import { DependenteService, ProcessoBeneficioService } from '../../../services';
import { HomeCard } from '../HomeCard/HomeCard';
import { Alert, Button, Row, Col, Badge } from '@intech/web-ui';

import { Calendario } from './Calendario';
import { UltimaFolha } from './UltimaFolha';
import { buscarBloqueio, NumFuncionalidade } from "./../../../helpers/BloqueioFuncionalidade";

import { Beneficiarios, ListaProcesso } from '@components';

interface IProps {
  plano: PlanoVinculadoEntidade;
}

export const Assistido: React.FC<IProps> = ({
  plano
}) => {

  const [AlertText, setAlertText] = useState<string>("");
  const [ProcessoBeneficio, setProcessoBeneficio] = useState<ProcessoBeneficioEntidade>(new ProcessoBeneficioEntidade());
  const [ListaProcessos, setListaProcessos] = useState<Array<ProcessoBeneficioEntidade>>(new Array<ProcessoBeneficioEntidade>());
  const [MotivoBloqueio, setMotivoBloqueio] = useState<string>("");

  useEffect(() => {
    (async () => {
      setMotivoBloqueio(await buscarBloqueio(NumFuncionalidade.HOME_ASISSTIDOS));
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        var processoBeneficio = await ProcessoBeneficioService.BuscarPorPlano(plano.CD_PLANO);

        if (processoBeneficio.length > 0) {
          setProcessoBeneficio(processoBeneficio[0]);
          setListaProcessos(processoBeneficio);
        }
      }
      catch (e) {
        const error = e.response ? e.response.data : e;
        console.log(error);
        setAlertText(error);
      }

    })();
  }, []);

  async function carregarProcesso(Processo: ProcessoBeneficioEntidade) {
    setProcessoBeneficio(Processo);
  }

  function renderListaProcesso() {
    if (ListaProcesso.length > 1) {
      const Processos = ListaProcessos.map((ProcessoItem: ProcessoBeneficioEntidade, index: number) => {
        const ProcessoSelecionado = ProcessoItem === ProcessoBeneficio;
        return (
          <Button
            key={index}
            title={ProcessoItem.DS_ESPECIE + " - " + ProcessoItem.ANO_PROCESSO + "/" + ProcessoItem.NUM_PROCESSO + " - " + ProcessoItem.DT_CONCESSAO}
            type={ProcessoSelecionado ? "secondary" : "primary"}
            disabled={ProcessoSelecionado}
            onClick={() => carregarProcesso(ProcessoItem)}
          />
        );
      });
      return (
        <Row>
          <Col>
            <Row className={"text-left"}>
              <Col>
                <span>{"Escolha um Processo:"}</span>
              </Col>
            </Row>
            <Row>
              <Col>
                {Processos}
              </Col>
            </Row>
          </Col>
        </Row>
      );
    }
    return null;
  }

  function renderHeader() {
    return (
      <>
        <Row>
          <Col>
            <HomeCard titulo={plano.DS_PLANO} subTitulo={`CNPB: ${plano.COD_CNPB}`}>
              {plano.DS_CATEGORIA}
            </HomeCard>
          </Col>
          {/* <Col>
            <HomeCard titulo={"Situação do Benefício"}>
              {ProcessoBeneficio.DS_SITUACAO}
            </HomeCard>
          </Col> */}
        </Row>
        {ListaProcessos.length > 0 && <Row>
          <Col>
            <HomeCard titulo={"Tipo de Benefício"}>
              {ProcessoBeneficio.DS_ESPECIE}
            </HomeCard>
          </Col>
          <Col>
            <HomeCard titulo={"Data de Concessão"}>
              {ProcessoBeneficio.DT_CONCESSAO}
            </HomeCard>
          </Col>
        </Row>}
      </>
    );
  }

  if (MotivoBloqueio !== "") {
    return (
      <Alert type={"danger"}>
        {MotivoBloqueio}
      </Alert>
    );
  }

  return (
    <>
      <ListaProcesso processos={ListaProcessos} dsProcessoAtivo={ProcessoBeneficio?.DS_PROCESSO!} onChange={carregarProcesso} textoInstrucao={"Escolha um Processo:"} />

      {AlertText !== "" && <Alert type={"danger"}>
        {AlertText}
      </Alert>}

      {/* <Row> */}
      {renderHeader()}
      {/* </Row> */}

      <Row>
        <Col>
          <Beneficiarios />
        </Col>
      </Row>

      <Row>
        <Col>
          <UltimaFolha plano={plano} processoBeneficio={ProcessoBeneficio} />
        </Col>
        <Col>
          <Calendario plano={plano} />
        </Col>
      </Row>
    </>
  );
}